import React from "react";
import Chart from "react-apexcharts";
import { HEATMAP_MONTHS, REVENUE_FILTER_OPTIONS } from "./dashboardUtils";

export const AdminRevenueKpiSection = ({
  monthlySnapshotLoading,
  monthlySnapshotError,
  selectedRevenueType,
  onRevenueTypeChange,
  currentMonthRevenue,
  lastMonthRevenue,
  revenueDelta,
  revenueDeltaPercent,
  revenueChartLoading,
  revenueChartError,
  revenueSeries,
  revenueOptions,
  revenueChartType,
  revenueTitle,
  selectedRevenueYear,
  yearList = [],
  onRevenueYearChange,
  selectedRevenueMonth,
  onRevenueMonthChange,
}) => {
  return (
    <div className="row g-3 mb-3">
      {/* <div className="col-md-12 col-lg-4">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center gap-2">
            <h6 className="card-title mb-0">Revenue Snapshot</h6>
            {!monthlySnapshotLoading && (
              <div className="small text-success fw-bold">
                {revenueDelta > 0 ? "+" : ""}
                {revenueDelta.toLocaleString("en-IN")} (
                {revenueDelta > 0 ? "+" : ""}
                {revenueDeltaPercent.toFixed(2)}%)
              </div>
            )}
          </div>
          <div className="card-body">
            {monthlySnapshotLoading ? (
              <p className="mb-0">Loading...</p>
            ) : (
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <div className="small text-muted">Current Month</div>
                  <h4 className="mb-0">{currentMonthRevenue.toLocaleString("en-IN")}</h4>
                </div>
                <div className="col-12 col-md-6">
                  <div className="small text-muted">Last Month</div>
                  <h4 className="mb-0">{lastMonthRevenue.toLocaleString("en-IN")}</h4>
                </div>
              </div>
            )}
            {!monthlySnapshotLoading && monthlySnapshotError && (
              <p className="small text-muted mt-2 mb-0">{monthlySnapshotError}</p>
            )}
          </div>
        </div>
      </div> */}

      <div className="col-md-12 col-lg-12">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h6 className="card-title mb-0">{revenueTitle}</h6>
            <div className="d-flex gap-2">
              <select
                className="form-select form-select-sm"
                value={selectedRevenueYear}
                onChange={onRevenueYearChange}
                style={{ width: "100px" }}
              >
                {yearList.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
              {selectedRevenueType === "daily" && (
                <select
                  className="form-select form-select-sm"
                  value={selectedRevenueMonth}
                  onChange={onRevenueMonthChange}
                  style={{ width: "120px" }}
                >
                  {HEATMAP_MONTHS.map((m, i) => (
                    <option key={m} value={i + 1}>
                      {m}
                    </option>
                  ))}
                </select>
              )}
              <select
                className="form-select form-select-sm"
                value={selectedRevenueType}
                onChange={onRevenueTypeChange}
                style={{ width: "140px" }}
              >
                {REVENUE_FILTER_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="card-body">
            {revenueChartLoading ? (
              <p className="mb-0">Loading...</p>
            ) : revenueChartError ? (
              <p className="mb-0 text-muted">{revenueChartError}</p>
            ) : revenueSeries.length > 0 ? (
              <Chart
                options={revenueOptions}
                series={revenueSeries}
                type={revenueChartType}
                height={320}
              />
            ) : (
              <p className="mb-0 text-muted">No revenue chart data available.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
